import { createSelector } from '@reduxjs/toolkit'

import { RootState } from '../configure_store'

const _getState = (state: RootState) => state.ivb

export const getPullingVehicleBranches = createSelector(
  _getState,
  (state) => state.products.filter(product => product.isPullingVehicle).map(product => product.brancheCode)
)

export const getTowedVehicleBranches = createSelector(
  _getState,
  (state) => state.products.filter(product => product.isTowedVehicle).map(product => product.brancheCode)
)
